export const iconFontAwesomeMusicVideoDrumSteelpan = (
	<i className="fa-solid fa-drum-steelpan"></i>
);
